module.exports = __webpack_public_path__ + "static/media/unselected_marker_stormwater.0698accb.svg";